<template>
  <ExternalQueryList
      headline="Top Menu Links"
      endpoint="/api/v2/top-menu-links"
      :endpoint-filters="{portal_id: portal.id}"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      reorder-endpoint="/api/v2/top-menu-links/priorities"
      :get-reorder-payload="data => ({top_menu_links: data})"
      @show="topMenuLink => $router.push(getUrl(topMenuLink))"
  >
    <template v-slot:default="{ row: topMenuLink }">
      <td>
        <router-link :to="getUrl(topMenuLink)">
          {{ topMenuLink.attributes.text }}
        </router-link>
      </td>

      <td>
        {{ topMenuLink.attributes.path }}
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link
          class="btn btn-white btn-sm"
          style="margin-top: 4px;"
          :to="'/portals/' + portal.id + '/content/top-menu-links/create'"
      >
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  props: {
    portal: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 10, text: 'Text'},
        {width: 10, text: 'Path'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(topMenuLink) {
      return '/portals/' + this.portal.id + '/content/top-menu-links/' + topMenuLink.id + '/edit'
    }
  }
}
</script>
